//题库列表请求参数
export default class QueryListForm {
  page = 1;
  pageSize = 10;
  companyId = 0;
  type?: number; //题目类型
  descLike?: string; //题目关键字
  companyIndex?: string; //题目编号
  remark?: string; //备注
  aiDimension?: string; //AI维度
}
